import React from 'react'

export const Tag = ({ label }) => (
  <span className="wb-tag wb-tag--tertiary wb-margin-vertical-3xs">
    {label}
  </span>
)
